import { FormikProps } from "formik";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import ATMHTMLEditor from "src/components/UI/atoms/formFields/ATMHTMLEditor/ATMHTMLEditor";
import ATMTextField from "src/components/UI/atoms/formFields/ATMTextField/ATMTextField";
import { ChapterFormValues } from "src/models/Chapter.model";
import { handleValidNumber } from "src/utils/validations/numberInput";

type Props = {
  formikProps: FormikProps<ChapterFormValues>;
  editorValue?: string;
};

const ChapterViewForm = ({ formikProps , editorValue =''   }: Props) => {
  const { values, setFieldValue, isSubmitting, handleBlur } = formikProps;

  return (
    <div className="flex p-4 flex-col gap-6 relative">
        <div className="text-[18px] text-primary-light font-medium underline-offset-2">CHAPTER DETAILS</div>
      <div className="flex flex-col gap-4">
        {/* Chapter Content */}
        <div className="text">
          <ATMHTMLEditor 
            key={editorValue}
            label="Description"
            required
            value={values?.chapterContent}
            placeholder="Write description here...."
            onChange={(newValue: any) => {
              setFieldValue("chapterContent", newValue);
            }}
          />
        </div>
        {/* Duration */}
        <div className="">
          <ATMTextField 
            required
            name="duration"
            value={values?.duration}
            onChange={(e) =>
              handleValidNumber(e) && setFieldValue("duration", e.target.value)
            }
            label="Duration (In Minutes)"
            placeholder="Enter Duration"
            onBlur={handleBlur}
          />
        </div>

      </div>
      <div className="flex justify-end">
      <div className="w-40">
        <ATMLoadingButton isLoading={isSubmitting} type="submit">
          Save
        </ATMLoadingButton>
      </div>
      </div>
    </div>
  );
};

export default ChapterViewForm;
